import { Table } from 'antd'
import dayjs from 'dayjs'
import { FC, useMemo } from 'react'
import PageLayout from '../../components/page-layout/page-layout'
import TableWrapper from '../../components/table-wrapper/table-wrapper'
import { useGetPrintJobsQuery } from '../../store/api/print-jobs-api'
import PrintJob, { JobStatuses } from '../../types/api/print-job'
import { getColumns } from './columns'
import MachineCountersBar from './components/machine-counters-bar/machine-counters-bar'
import { completedPrintJobsQueryParams } from './constants/query-params'

function isFinishedPrintJob(job: PrintJob): boolean {
    if (job.jobStatus === JobStatuses.Completed || job.jobStatus === JobStatuses.Cancelled) {
        return true
    }

    if (job.jobStatus === JobStatuses.Printing) {
        const hasQueue = (job.print_queue_entries || []).length > 0
        const executors = job.print_job_executors || []

        return executors.length > 0 && !hasQueue && executors.every(e => e.end)
    }

    return false
}

function getLatestExecutorEndTimestamp(job: PrintJob): number {
    const latestEnd = (job.print_job_executors || [])
        .map(executor => executor.end)
        .filter(Boolean)
        .sort((a, b) => dayjs(a!).valueOf() - dayjs(b!).valueOf())
        .at(-1)

    return latestEnd ? dayjs(latestEnd).valueOf() : 0
}

const CompletedPrintJobsPage: FC = () => {
    const { data, isLoading, refetch } = useGetPrintJobsQuery(completedPrintJobsQueryParams)

    const dataSource = useMemo(
        () =>
            (data?.data || [])
                .filter(isFinishedPrintJob)
                .sort(
                    (a, b) => getLatestExecutorEndTimestamp(b) - getLatestExecutorEndTimestamp(a)
                ),
        [data?.data]
    )

    const columns = useMemo(() => getColumns(refetch), [refetch])

    return (
        <PageLayout title="Расход">
            <MachineCountersBar />
            <TableWrapper style={{ flex: 'auto' }}>
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    rowKey="documentId"
                    size="small"
                    loading={isLoading}
                    scroll={{ x: 'max-content' }}
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default CompletedPrintJobsPage
